import { RAPORTORLERI_GUNCELLE } from "../constants/requestUrls";

import { postRequest } from "../request";

const raportorleriGuncelle = (data) => {
  return postRequest({ url: RAPORTORLERI_GUNCELLE, data });
}

export default raportorleriGuncelle;